<template>
  <div class="fadein">
    <transition name="el-zoom-in-center">
      <div v-if="trans==1">
        <Goback></Goback>
        <div class="h30"></div>
    <div class="center1200 bg-white" style="position:relative;">
        <div class="h20"></div>
        
        <div class="center-title" >
          <span><img class="title-pic" src="/static/img/title-left.png" alt=""> 今日话题 <img class="title-pic" src="/static/img/title-right.png" alt=""></span>
          <el-breadcrumb separator="/" style="position:absolute;left:30px;top:30px;">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/forum' }"
              >论坛</el-breadcrumb-item
            >
            <el-breadcrumb-item>话题详情</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <span  @click="goback" >返回</span> -->
        </div>
        <!-- <div class="h20"></div> -->
        <div style="padding:20px;">
          <div style="text-align: center;">
            <h2>{{detail.title}}</h2>
            <div style="color:#999;"><i class="el-icon-view"></i>{{detail.reviews_count}} {{detail.desn}} </div>
            <span v-if="vote_form.user_id==detail.user_id">
              <div class="h10"></div>

              <span class="delete-topic" @click="deleteTopic()">删除话题</span>
            </span>
            <span v-else>
              <div class="h10"></div>
              <div v-if="vote_form.user_id != null">

                <el-tooltip class="item" effect="dark" content="举报此话题" placement="top" style="margin-right:0px;">
                  <div class="report" @click="showTopicDialogReport()" ></div>
                </el-tooltip>
              </div>
              <!-- <span class="delete-topic" @click="showTopicDialogReport()">举报话题</span> -->
            </span>
            <div class="h10"></div>
            <span class="user-box" @click="goUserinfo(detail.user_id)">
              <img  class="topic-userpic" :src="detail.user_info.extras.user_pic" alt="" v-if="detail.user_info.extras.user_pic!='http://'+ $API_URL" >
              <img  class="topic-userpic" src="/static/img/default_userpic.png" alt="" v-else>
              <div class="username" v-if="detail.user_info.extras.nickname!=null">{{detail.user_info.extras.nickname}}</div>
              <div class="username" v-else>{{detail.user_info.mobile}}</div>
            </span>
            
            <div class="h20"></div>
            <div v-if="judge_vote==0">
              <div v-if="detail.is_checkbox == 0" >
                <el-radio-group v-model="radio_id">
                  <div v-for="v,k in detail.detail" >
                    <el-radio :label="v.id" border class="radio-option">{{v.options}}</el-radio>
                    <div class="h20"></div>
                  </div>
                </el-radio-group>
              </div>
              <div v-if="detail.is_checkbox == 1">
                <el-checkbox-group v-model="vote_form.option_id">
                  <div v-for="v,k in detail.detail">
                    <el-checkbox :label="v.id" border>{{v.options}}</el-checkbox>
                    <div class="h20"></div>
                  </div>
  
              </el-checkbox-group>

              </div>
              <div class="h20"></div>

              <div style="text-align:center;" v-if="vote_form.user_id != null">
                <el-button type="primary" style="width:120px;" @click="vote()">参 与</el-button>
              </div>
              <div style="text-align:center;" v-else>
                <router-link to="/login">
                <el-button type="success" style="width:120px;">登录参与</el-button>
                </router-link>
              </div>
            </div>
            <div v-else>
              <transition name="el-zoom-in-center">
              <div v-if="judge_vote == 1">
              <div v-for="v,k in detail.detail">
                <div class="progress-box">
                  <el-progress class="progress" :stroke-width="30" :percentage="v.count/detail.count*100" :show-text="false" :color="pro_color[k%5]"></el-progress>
                  <div class="progress-span">{{v.options}}：{{v.count/detail.count*100 | numFilter}}%</div>
                </div>
              </div>
              </div>
              </transition>


            </div>
          </div>
          
          
            
        </div>
        <div style="height:50px;"></div>
    </div>
    <div class="h30"></div>
    <!-- 举报话题 Start -->
      <el-dialog title="举报话题" :visible.sync="topic_dialog_report_visible">
        <el-form :model="report_form">
        <el-form-item label="举报的话题为：" :label-width="formLabelWidth">
            <el-input v-model="detail.title" autocomplete="off" disabled ></el-input>
        </el-form-item>
        <el-form-item label="违规行为：" :label-width="formLabelWidth">

            <el-radio-group v-model="report_form.report_reason" style="line-height: 40px;margin-top:5px;">
                <el-radio label="违法违规">违法违规</el-radio>
                <el-radio label="色情低俗">色情低俗</el-radio>
                <el-radio label="赌博诈骗">赌博诈骗</el-radio>
                <el-radio label="人身攻击">人身攻击</el-radio>
                <el-radio label="侵犯隐私">侵犯隐私</el-radio>
                <el-radio label="垃圾广告">垃圾广告</el-radio>
                <el-radio label="不明链接">不明链接</el-radio>
                <el-radio label="引战">引战</el-radio>
                <el-radio label="剧透">剧透</el-radio>
                <el-radio label="其他">其他</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="举报原因：" :label-width="formLabelWidth">
            <el-input
            type="textarea"
            placeholder="请说明举报原因"
            v-model="report_form.report_content"
            maxlength="100"
            :autosize="{ minRows: 5 }"
            show-word-limit
            >
            </el-input>
        </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button @click="topic_dialog_report_visible = false">取 消</el-button>
        <el-button type="info" @click="sendReportTopic()">确 定</el-button>
        </div>
    </el-dialog>
    <!-- 举报话题 End -->
      </div>

  </transition> 
</div>
    
</template>

<script>
  import Goback from '@/components/components/goback'



  export default {
    
components:{
            Goback,

        },
    data() {
      return {
        
        vote_form:{
          user_id:0,
          option_id:[],
        },
        tid:0,
        detail:{
          user_id:0,
          user_info:{
            extras:{

            }
          },
          reviews_count:0,
        },
        report_form:{
          report_reason:'',
          report_content:'',
        },
        topic_dialog_report_visible:false,
        trans : 0,
        //单选时的id （为了将id推入数组）
        radio_id:0,
        judge_vote:0,
        pro_color:['#ff7400','#00ab6f','#ff2b78','#009999','#5e5b7d'],
        formLabelWidth: "120px",

      }
    },
    filters: {
      numFilter (value) {
        let realVal = ''
        if (!isNaN(value) && value!== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = '--'
        }
        return realVal
      }
    },
    watch:{
      $route(newVal,oldVal){
        this.trans = 0
        this.judge_vote = 0
        this.detail={
          user_id:0,
          user_info:{
            extras:{

            }
          },
          reviews_count:0,
        }
        if(newVal.name == 'topicdetail'){
          this.vote_form.user_id = localStorage.getItem('token')
          this.$parent.activeIndex = '4'
          this.tid = this.$route.params.tid
          this.judgeVote()
          this.getTopicDetail()
        }
      }
    },
    mounted(){
      this.trans = 0
      this.judge_vote = 0
      this.vote_form.user_id = localStorage.getItem('token')
      this.$parent.activeIndex = '4'
      this.tid = this.$route.params.tid
      this.judgeVote()
      this.getTopicDetail()
    },
    methods:{
      //获取话题详情
      getTopicDetail(){
        $.ajax({
          url:"//" + this.$API_URL + "/api/v1/votes/"+this.tid,
          type:"get",
          success:(ret)=>{
            this.detail = ret.data;
            console.log(this.detail)
            this.trans = 1
          }
        })
      },
      //删除话题
      deleteTopic(){
        this.$confirm("此操作将删除该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.ajax({
          url:"//"+ this.$API_URL +"/api/v1/votes/delete_self_votes/"+this.tid,
          type:"post",
          data:{user_id:this.detail.user_id},
          success:(ret)=>{
            this.$message({
                showClose:true,
                message:"话题删除成功~",
                type:"success"
            })
            this.goback();
          }
        })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });



      },
      //举报话题
      sendReportTopic(){
        // 
        if(this.report_form.report_reason==""){
            this.$message({
                showClose:true,
                message:"请选择违规行为",
                type:"info"
            })
            return false;
        }
        $.ajax({
            url:"//" + this.$API_URL + "/api/v1/votes/report/"+this.tid,
            type:"post",
            data:{report_user_id:localStorage.getItem('token'),reasons:this.report_form.report_reason,content:this.report_form.report_content},
            success:(ret)=>{
                this.$message({
                    showClose:true,
                    message:ret.msg,
                    type:"info"
                })
                this.topic_dialog_report_visible = false;
            }
        })
      },

      //投票
      vote(){
        // console.log(this.vote_form)
        if(this.detail.is_checkbox==0){
          // console.log(this.radio_id)
          this.vote_form.option_id.push(this.radio_id)
        }
        // console.log(this.vote_form)
        $.ajax({
          url:"//"+ this.$API_URL +"/api/v1/votes/vote/"+this.tid,
          type:"post",
          data:this.vote_form,
          success:(ret)=>{
            // console.log(ret)
            if(ret.code == 201){
              this.$message({
                  showClose:true,
                  message:"参与成功~",
                  type:"success"
              })
              this.trans = 0
              this.judge_vote = 1
              this.vote_form.option_id = []; 
              this.getTopicDetail()
            }else{
              this.$message({
                  showClose:true,
                  message:ret.msg,
                  type:"info"
              })
            }
          }
        })
      },
      
      //判断用户是否投票
      judgeVote(){
        $.ajax({
          url:"//" + this.$API_URL + "/api/v1/votes/is_vote/"+this.tid,
          type:"post",
          data:{user_id:localStorage.getItem('token')},
          success:(ret)=>{
            if(ret.code==200){
              this.judge_vote = 1
            }
          }
        })
      },
      
      //显示举报评论对话框
      showTopicDialogReport(id,nickname,comment){

        this.topic_dialog_report_visible = true;
      },
      //点击用户名或头像跳转到用户信息页
      goUserinfo(uid){
        this.$router.push('/user/'+uid).catch(err => {err});
      },
      goback(){
        this.$router.go(-1);
      },
    }
  }

</script>
  
<style scoped>
.topic-userpic{
  cursor: pointer;
  border:1px solid #fff;
  width:80px;
  height:80px;
  border-radius: 50%;
}
.user-box{
  width:auto;
}
.user-box:hover .topic-userpic{
  border:1px solid #ff7400;
}
.username{
  cursor: pointer;
  color:#303133;
  font-family: "PingFang SC";
  font-size:16px;
}
.user-box:hover .username{
  color:#ff7400;
}

/* element */
.el-checkbox.is-bordered {
  min-width:400px;
  margin-right: 0;
}
.progress-box{
  position: relative;
  width:400px;
  margin:0 auto;
  height: 30px;
  margin-bottom:20px;

}
.progress{
  /* margin:0 auto; */
  /* width:400px; */
}
.progress-span{
  position: absolute;
  width:400px;
  top:4px;
  /* left:100px; */
  /* margin-top:-100px; */
  margin-left:-50%;
  text-align: center;
  margin:0 auto;
  color:rgb(255, 255, 255);
}
.radio-option{
  margin:0 auto;
  text-align: center;
}
.delete-topic{
  cursor: pointer;
  color:#666;
}
.delete-topic:hover{
  color:#ff2b78;
}
</style> 
<style>
.el-progress-bar__outer{
  background-color:#b1b8c5 !important;
}
</style>
<style scoped>
.report{
    margin:0 auto !important;
    text-align: center;
    cursor: pointer;
    border:1px solid #ccc;
    border-radius: 50%;
    margin-top:15px;
    vertical-align: middle;
    width:20px;
    height:20px;
    background-image: url("/static/icon/report.png");
    background-size: 20px 20px;
}
.report:hover{
    cursor: pointer;
    border-radius: 50%;
    border:1px solid red;
    background-image: url("/static/icon/report_at.png");
}
</style>



// WEBPACK FOOTER //
// src/components/index/topicdetail.vue